export type ToolStatus = 'live' | 'coming_soon'

export interface ToolDef {
  slug: string
  status: ToolStatus
  href: string
  exclusiveWith?: readonly string[]
}

export const TOOLS: readonly ToolDef[] = [
  {
    slug: 'security-audit-alerts',
    status: 'live',
    href: '/tools/security-audit-alerts',
    exclusiveWith: ['ppms-audit'],
  },
  {
    slug: 'ppms-audit',
    status: 'live',
    href: '/tools/ppms-audit',
    exclusiveWith: ['security-audit-alerts'],
  },
  {
    slug: 'compliance-audit',
    status: 'live',
    href: '/tools/compliance-audit',
  },
  {
    slug: 'solution-configurator',
    status: 'live',
    href: '/tools/solution-configurator',
  },
]

export function getOtherTools(currentSlug: string): readonly ToolDef[] {
  const current = TOOLS.find((tool) => tool.slug === currentSlug)
  const excluded = new Set(current?.exclusiveWith ?? [])
  return TOOLS.filter(
    (tool) => tool.slug !== currentSlug && !excluded.has(tool.slug),
  )
}
